// Device ID to Friendly Name Mapping
export const DEVICE_ID_TO_NAME_MAP = {
  "373137381932343431332F55": "AGAMA 2",
  "373137381932343431332F57": "PS-157",
  "3637544A163832323032106A": "PR-004",
  Bat456: "Test Device 1",
  Rat789: "Test Device 2",
  1234: "Prototype Device 1",
  12345: "New Device",
};

export const FILTER_FIELD_DEFS = [
  {
    key: "device_name",
    label: "Device Name",
    type: "exact",
  },
  ...[
    "system_voltage",
    "v1_set_pressure",
    "v1_hyd_pressure",
    "v1_ind_pressure",
    "v1_avg_line_pressure",
    "v2_set_pressure",
    "v2_hyd_pressure",
    "v2_ind_pressure",
    "v2_avg_line_pressure",
  ].map((key) => ({
    key,
    label: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    type: "interval",
  })),
];
